import { PageStepper } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useIsWorkflowTrackerEnabled } from "shared-ui";

import { MESSAGES } from "./message-definitions";

export const OnboardingStepperNext = ({ currentStep }: { currentStep: number }) => {
  const intl = useIntl();
  const isWorkflowTrackerEnabled = useIsWorkflowTrackerEnabled();

  if (isWorkflowTrackerEnabled) {
    return <div></div>;
  }

  const ONBOARDING_STEPS = [
    intl.formatMessage(MESSAGES.stepBusinessCountry),
    intl.formatMessage(MESSAGES.stepMonthlyRevenue),
    intl.formatMessage(MESSAGES.stepBusinessDetails),
    intl.formatMessage(MESSAGES.stepConnectionsAndData),
    intl.formatMessage(MESSAGES.stepApplicationReview),
  ];

  return <PageStepper currentIndex={currentStep} steps={ONBOARDING_STEPS} maxVisibleSteps={ONBOARDING_STEPS.length} />;
};
